var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.8285 4.22776L4.22879 10.8274C3.96844 11.0878 3.96844 11.5099 4.22879 11.7702C4.48914 12.0306 4.91125 12.0306 5.1716 11.7702L11.7713 5.17057C12.0316 4.91022 12.0316 4.48811 11.7713 4.22776C11.5109 3.96741 11.0888 3.96741 10.8285 4.22776Z",
    fill: "#737A91"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.7712 10.8289L5.17154 4.22922C4.91119 3.96887 4.48908 3.96887 4.22873 4.22922C3.96838 4.48957 3.96838 4.91168 4.22873 5.17203L10.8284 11.7717C11.0887 12.032 11.5109 12.032 11.7712 11.7717C12.0316 11.5113 12.0316 11.0892 11.7712 10.8289Z",
    fill: "#737A91"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/close.845977e795065d5e1697b207e7f5eb08.svg";
export { ForwardRef as ReactComponent };